import { UserLangCode } from "src/utils/util.types";
import { StatisticsType } from "../types/statistics.entity";
import { BaseStatAggregator } from "./base/base-stat-aggregator";
import { bookingRepository } from "src/features/bookings/repositories/booking.repository";
import { Timestamp } from "firebase/firestore";
import { DateUtils } from "src/utils/date.util";

export class BookingStatsAggregator extends BaseStatAggregator {
  protected execQuery(statType: StatisticsType, langCode?: UserLangCode): Promise<number> {
    if (statType == "LAST_MONTH_BOOKINGS")
      return bookingRepository.count({
        date: {
          $gte: Timestamp.fromDate(DateUtils.subtract(new Date(), 30, "day").toJSDate()),
        },
        langCode,
      });
    else return bookingRepository.count({ langCode });
  }
}
